import keycloak from "@/keycloak";

const dashboardRedirectUri = `${process.env.VUE_APP_URL}/dashboard`;

export function loginWithCredentials() {
    return keycloak.login({
        redirectUri: dashboardRedirectUri,
    });
}

export function loginWithMicrosoftProvider() {
    return keycloak.login({
        redirectUri: dashboardRedirectUri,
        idpHint: "microsoft",
    });
}
